// extracted by mini-css-extract-plugin
export default {"counters":"visitsCounter_counters__ODA3B","counter":"visitsCounter_counter__8vlg0","number":"visitsCounter_number__cjLrW","title":"visitsCounter_title__n6A+5"};